import {
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';

import { BfwUserContextService, Notify, SubscribedEvents } from 'generatedBfw/static';

export const useSubscribedEventsQueryKey = ['subscribed-events'] as QueryKey;

export const useSubscribedEvents = (options?: UseQueryOptions<SubscribedEvents>) =>
  useQuery(
    useSubscribedEventsQueryKey,
    () => BfwUserContextService.getSubscribedEvents1(),
    options,
  );

export const useSubscribeToEvent = (eventId: Guid, options?: UseMutationOptions<Notify>) =>
  useMutation(
    ['subscribe-to-event', eventId],
    () => BfwUserContextService.subscribeToEvent(eventId),
    options,
  );

export const useUnsubscribeFromEvent = (eventId: Guid, options?: UseMutationOptions<boolean>) =>
  useMutation(
    ['unsubscribe-from-event', eventId],
    () => BfwUserContextService.unsubscribeFromEvent(eventId),
    options,
  );
